import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";
import { FadeUp, SectionHeading } from "./Shared";

export const Workflow = () => {
    const { lang } = useLang();
    const t = STR.workflow[lang];

    return (
        <section id="alur-kerja" data-testid="workflow-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-4xl px-5 md:px-8">
                <SectionHeading eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle} />
                <ol className="relative space-y-10 border-l-2 border-white/10 pl-8 md:pl-12">
                    {t.steps.map((step, i) => (
                        <FadeUp key={step.title} delay={i * 0.08}>
                            <li data-testid={`workflow-step-${i + 1}`} className="relative">
                                <span className="btn-flame absolute -left-[3.30rem] flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white shadow-lg shadow-orange-900/40 md:-left-[4.05rem] md:h-11 md:w-11">
                                    {i + 1}
                                </span>
                                <div className="card-surface p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-amber-400/30 md:p-7">
                                    <h3 className="text-lg font-semibold text-slate-50">{step.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-zinc-400">{step.desc}</p>
                                </div>
                            </li>
                        </FadeUp>
                    ))}
                </ol>
            </div>
        </section>
    );
};
